import { theme } from "../styles/theme";

function Sidebar({ onAgregar, onAgregarDocente, onCopiarEnlaceInvitado, enlaceCopiado, soloLectura }) {
  return (
    <div style={styles.container}>
      <h3 style={styles.title}>INFORMACIÓN ACADÉMICA</h3>

      {!soloLectura ? (
        <>
          <button style={styles.button} onClick={onAgregar}>
            + AGREGAR NUEVO
          </button>

          <button style={styles.secondaryButton} onClick={onAgregarDocente}>
            + AGREGAR DOCENTE
          </button>

          <button style={styles.copyButton} onClick={onCopiarEnlaceInvitado}>
            {enlaceCopiado ? "ENLACE COPIADO" : "COPIAR ENLACE INVITADO"}
          </button>
        </>
      ) : (
        <div style={styles.readOnlyBox}>
          <span style={styles.readOnlyTitle}>Modo invitado</span>
          <span style={styles.readOnlyText}>Acceso solo para consulta.</span>
        </div>
      )}

      <p style={styles.description}>
        Panel institucional para registrar, consultar y actualizar informacion del programa.
      </p>
    </div>
  );
}

export default Sidebar;

const styles = {
  container: {
    width: "250px",
    minWidth: "250px",
    background: theme.colors.sidebarBg,
    padding: "20px",
    borderRight: `1px solid ${theme.colors.border}`,
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    color: theme.colors.subtext
  },

  title: {
    fontSize: "16px",
    fontWeight: "bold",
    color: theme.colors.text
  },

  description: {
    margin: 0,
    color: theme.colors.subtext,
    fontSize: "14px",
    lineHeight: 1.5
  },

  button: {
    background: `linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.headerEnd})`,
    color: "#fff",
    border: "none",
    padding: "12px",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "0.3s",
    boxShadow: "0 10px 20px rgba(19, 59, 104, 0.18)"
  },

  secondaryButton: {
    background: theme.colors.panelBg,
    color: theme.colors.primary,
    border: `1px solid ${theme.colors.border}`,
    padding: "12px",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "bold"
  },

  copyButton: {
    background: "#eef6ff",
    color: theme.colors.primary,
    border: `1px dashed ${theme.colors.primary}`,
    padding: "12px",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "bold"
  },

  readOnlyBox: {
    background: theme.colors.panelBg,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: "10px",
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "6px"
  },

  readOnlyTitle: {
    color: theme.colors.primary,
    fontSize: "13px",
    fontWeight: "bold"
  },

  readOnlyText: {
    color: theme.colors.subtext,
    fontSize: "13px",
    lineHeight: 1.4
  }
};
